import {useFormContext} from '@yandex-delivery/form'
import {memo} from 'react'

import {PaymentInfoControl} from './PaymentInfoControl'

type Props = {
  name: string
}

export const PaymentInfo = memo<Props>(function PaymentInfo({name}) {
  const {watch} = useFormContext()
  const paymentMethodId = watch('paymentMethod.id')

  return paymentMethodId ? <PaymentInfoControl key={paymentMethodId} name={name} /> : null
})
